import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Dialog from '../../common/component/form/Dialog';
import TextInput from '../../common/component/form/TextInput';
import teamApi from '../../team/api/teamApi';

export default function TeamDialog({
                                       clubId,
                                       open,
                                       onSave,
                                       onCancel,
                                       title,
                                       team: initialTeam
                                   }) {
    const [t] = useTranslation();
    const [team, setTeam] = useState(null);

    useEffect(() => {
        if (open) {
            setTeam(initialTeam ? {...initialTeam} : {
                name: null,
                club: {id: clubId},
                season: new Date().getFullYear()
            });
        }
    }, [open]);

    const handleChange = (key, value) => {
        const updatedTeam = {...team};
        updatedTeam[key] = value;
        setTeam(updatedTeam);
    };

    const handleSave = () => {
        teamApi.createOrUpdateTeam(team).then(response => {
            if (response.data.success) {
                onSave();
            }
        });
    };

    if (!team) {
        return null;
    }

    return (
        <Dialog
            open={open}
            title={title}
            footer={
                <>
                    <button
                        onClick={onCancel}
                        type="button"
                        className="btn btn-transparent-primary">
                        <FontAwesomeIcon icon="times" className="mr-2"/>
                        {t('Button.CANCEL')}
                    </button>

                    <button
                        onClick={handleSave}
                        type="button"
                        className="btn btn-primary">
                        <FontAwesomeIcon icon="check" className="mr-2"/>
                        {t('Button.SAVE')}
                    </button>
                </>
            }
        >
            <TextInput
                label={t('Team.NAME')}
                value={team.name}
                onChange={value => handleChange('name', value)}
            />
        </Dialog>
    );
}
